import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import { Avatar, Popover, Radio } from "antd";
import Api from "./api";
import Image from "./image";
import Help from "./help";
import "../styles/console.css";
import "../styles/header.css";
import { USERS } from "./users";

class Console extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            platform: "development",
            user: 0,
            notification: 0,
            server: null
        };
    }

    componentDidMount() {
        if (localStorage.getItem("ejbank_user")) {
            this.setState({user: JSON.parse(localStorage.getItem("ejbank_user"))});
        } else {
            localStorage.setItem("ejbank_user", 0);
        }
        if (localStorage.getItem("ejbank_server")) {
            this.setState({platform: localStorage.getItem("ejbank_server")});
        } else {
            localStorage.setItem("ejbank_server", "development");
        }
        this.checkNotification();
        this.checkServer();
    }
    
    checkServer = () => {
        Api("check_server", {}).then(server => { this.setState({server}); });
    }
    
    changeServer = (e) => {
        let {platform} = this.state;
        const {onChangeUser} = this.props;
        platform = e.target.value;
        localStorage.setItem("ejbank_server", platform);
        this.setState({platform});
        this.checkNotification();
        this.checkServer();
        if (onChangeUser) {
            onChangeUser();
        }
    }

    changeUser = () => {
        let {user} = this.state;
        const {onChangeUser} = this.props;
        user = (user + 1) % USERS.length;
        localStorage.setItem("ejbank_user", user);
        this.setState({user});
        this.checkNotification();
        if (onChangeUser) {
            onChangeUser();
        }
    }

    checkNotification = () => {
        this.setState({notification: 0});
        Api("transaction_validation_notification", {})
                .then(notification => {
                    this.setState({notification});
                });
    }

    render() {
        const {children, menu, help} = this.props;
        const {user, server, notification, platform} = this.state;
        const radioStyle = {
            display: 'block'
        };
        return (<React.Fragment>
            <div className="console">
                <header>
                    <div className="left">
                        <div>
                            <Image src="piggy-bank.png" />
                        </div>
                        <div>EJBank</div>
                    </div>
                    <div className="right">
                        <div>
                            <Popover placement="bottomRight" content={
                        <Help keys = {help} />
                            } title={
                        <div className = "popup_title" >Aide</div>
                            }>
                            <Avatar size={64} icon="question" style={{backgroundColor: "white", color: "black", verticalAlign: 'middle'}}  />
                            </Popover>
                        </div>
                        <div>
                            <Popover placement="bottomRight" content={
                        <React.Fragment>
                            <div>{server && server.result ? "Le serveur est actuellement actif" : "Vous devez lancer votre serveur sur https://localhost:8001"}</div>
                            { false && <React.Fragment>
                            <div><br/>Choisir l'environnement du back-end :</div>
                            <Radio.Group onChange={this.changeServer} value={platform}>
                                <Radio value={"development"} style={radioStyle}>
                                    Developpement
                                </Radio>
                                <Radio value={"production"} style={radioStyle}>
                                    Production
                                </Radio>
                            </Radio.Group>
                            </React.Fragment>
                            }
                        </React.Fragment>
                        } title={
                        <div className = "popup_title" >Statut</div>
                        }>
                        <Avatar size={64} icon={ server === null ? "loading" : server.result ? "check" : "close" } style={{backgroundColor: "white", color: "black", verticalAlign: 'middle'}}  />
                        </Popover>
                    </div>
                    <div>
                        <Avatar size={64}
                                style={{backgroundColor: "white", color: "black", verticalAlign: 'middle'}}
                                onClick={this.changeUser} className="user">
                            { USERS[user].name }
                        </Avatar>
                    </div>
            </div>
            <div className="clear"></div>
        </header>
        <main>
            <div className="menu">
                <li className={menu === "accounts" ? "active" : ""}><Link to="/accounts">Liste des comptes</Link></li>
                <li className={menu === "transaction" ? "active" : ""}><Link to="/transaction">Réaliser une transaction</Link></li>
                <li className={menu === "externals" ? "active" : ""}><Link to="/externals">Comptes externes</Link>{ notification > 0 && <Avatar className="notification">{notification}</Avatar>}</li>
                { false && <li className={menu === "messages" ? "active" : ""}><Link to="/messages">Messages</Link></li> }
                <li><Link to="/">Retour au site</Link></li>
            </div>
            <div className="content">{children}</div>
        </main>
        <footer>
        </footer>
        </div>
        </React.Fragment>);
    }
}
;

Console.propTypes = {
    children: PropTypes.node.isRequired,
    menu: PropTypes.string,
    help: PropTypes.array
};

Console.defaultProps = {
    help: []
};

export default Console;
